import { defineSlotRecipe } from "@pandacss/dev";

export const aromaCheckbox = defineSlotRecipe({
  slots: [
    "container",
    "control",
    "title",
    "subtitle",
    "label",
    "icon",
    "errorText",
    "errorContainer",
  ],
  className: "aroma-checkbox",
  jsx: ["Checkbox", "Checkbox.Item", "AromaCheckbox"],
  base: {
    container: {
      gap: "gap.2",
      cursor: "pointer",
    },
    label: {
      display: "flex",
      flexDirection: "column",
    },
    icon: {
      color: "background.neutral.base.subtlest",
      display: "flex",
      _disabled: {
        color: "content.brand.subtlest",
      },
    },
    errorText: {
      textStyle: "paragraph.m.regular",
    },
    errorContainer: {
      gap: "gap.1",
      color: "content.functional.error",
    },
    control: {
      width: "xs",
      height: "xs",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: 0,
      backgroundColor: "background.neutral.base.subtlest",
      borderWidth: "thin",
      borderColor: "border.neutral.bold",
      borderRadius: "s",
      _hover: {
        backgroundColor: "background.neutral.base.subtlest-hover",
        borderColor: "border.neutral.bold-hover",
      },
      _focusVisible: {
        borderColor: "border.brand-bold",
        shadow: "effect.focus-ring.brand",
      },
      _checked: {
        backgroundColor: "background.brand.bold",
        borderColor: "background.brand.bold",
        _hover: {
          backgroundColor: "background.brand.bold-hover",
          borderColor: "background.brand.bold-hover",
        },
        _invalid: {
          backgroundColor: "background.functional.error.bold",
          borderColor: "background.functional.error.bold",
          _hover: {
            backgroundColor: "background.functional.error.bold-hover",
            borderColor: "background.functional.error.bold",
          },
          _focusVisible: {
            shadow: "effect.focus-ring.error",
          },
        },
        _disabled: {
          backgroundColor: "background.brand.subtle",
          borderColor: "background.brand.subtle",
        },
      },
      _indeterminate: {
        backgroundColor: "background.brand.bold",
        borderColor: "background.brand.bold",
        _hover: {
          backgroundColor: "background.brand.bold-hover",
          borderColor: "background.brand.bold-hover",
        },
        _invalid: {
          backgroundColor: "background.functional.error.bold",
          borderColor: "background.functional.error.bold",
          _hover: {
            backgroundColor: "background.functional.error.bold-hover",
            borderColor: "background.functional.error.bold",
          },
          _focusVisible: {
            shadow: "effect.focus-ring.error",
          },
        },
        _disabled: {
          backgroundColor: "background.brand.subtle",
          borderColor: "background.brand.subtle",
        },
      },
      _invalid: {
        backgroundColor: "background.functional.error.subtle",
        borderColor: "border.functional.error",
        _hover: {
          backgroundColor: "background.functional.error.subtle-hover",
          borderColor: "border.functional.error",
        },
        _focusVisible: {
          borderColor: "border.functional.error",
          shadow: "effect.focus-ring.error",
        },
      },
      _disabled: {
        backgroundColor: "background.neutral.disable.bold",
        borderColor: "background.neutral.disable.bold",
      },
    },
    subtitle: {
      textStyle: "paragraph.m.regular",
      color: "content.neutral.base.subtle",
    },
  },
  variants: {
    hierarchy: {
      bold: {
        title: {
          textStyle: "title.s",
        },
      },
      subtle: {
        title: {
          textStyle: "paragraph.m.regular",
        },
        subtitle: {
          display: "none",
        },
      },
    },
    size: {
      small: {},
      medium: {
        container: {
          paddingY: "10px",
          paddingX: "padding.3",
        },
      },
    },
  },
  defaultVariants: {
    hierarchy: "bold",
    size: "small",
  },
});
